module.exports = __webpack_public_path__ + "static/media/Asset 5.43904408.svg";